var exports = {
  "A": "x2b2fbebb--025376--item",
};

module.exports = exports;
